import PagesServices from "../../services/PagesServices";
import {
  buildPagesConfigExecutePayload,
  wrapPagesConfigExecutePayload,
  evaluatePagesMessageCondition,
  orderToPageMappingForExecute,
  resolveAndNavigateRedirect,
  isToPageRedirectMode,
  resolveMappedVariableValue,
  resolveSamePageHostConfig,
  resolveIsSamePageAutomation,
  buildPagesRedirectFieldOutputs,
  normalizePagesGetRatesRedirectOutputs,
  resolvePagesHttpErrorMessage,
  isPagesConfigNotFoundError,
  buildPagesRouteQuery,
} from "../../Containers/PagesContainer/PagesContainerUtils";
import {
  ensureGetRatesMarkupOutputResponse,
  persistGetRatesExecuteResponse,
  resolvePagesRedirectTargetConfigApiName,
  resolvePagesTargetConfigKey,
  isGetRatesPageRedirectTarget,
  omitEphemeralPagesParams,
  buildFieldFormPayloadFromExecuteMappings,
  collectRatesResultsPageDataKeys,
  mergeSamePageExecuteOutputs,
  applyMappedExecuteOutputsToParams,
} from "../../Containers/PagesContainer/getRatesPagesUtils";
import {
  applyPagesConfigFeatureFlags,
  isRatesResultsConfig,
  isRatesResultsPageId,
  setShipmentEditSessionActive,
} from "../../Containers/PagesContainer/pagesFeatureConfig";
import { isSet, conditionRulesChecking } from "../../Utils/CommonFunctions";
import { getGoBackURL, setGoBackURL } from "../../Utils/UserFunctions";
import http from "../../services/http";
import { buildMergedPagesExecuteParams } from "../../Containers/PagesContainer/pagesAutomationUtils";
import { collectPageDataKeysForConfig } from "../../Containers/PagesContainer/pagesRuntimeCacheUtils";
import { 
  SET_FROM_MAPPING,
  SET_RESOURCES_LIST,
  UPDATE_FROM_MAPPING_FIELDS,
  REMOVE_FROM_MAPPING_FIELD,
  SET_TO_PAGES,
  SET_TO_MAPPING,
  UPDATE_TO_MAPPING_FIELDS,
  REMOVE_TO_MAPPING_FIELD,
  SET_TO_PAGE_CONDITION,
  CLEAR_PAGES_CONFIG,
  ADD_PENDING_DELETED_VARIABLE,
  CLEAR_PENDING_DELETED_VARIABLES,
  REMOVE_TO_PAGES,
  UPDATE_TO_PAGE,
  LOAD_CONFIG_COLLECTION,
  LOAD_CONFIG_COLLECTION_SILENT,
  SET_ACTIVE_CONFIG_PAGE,
  REMOVE_ACTIVE_POPUP_PAGE,
  SET_RESOURCES_LIST_BY_TYPE,
  UPDATE_PAGE_FLOWS_DATA,
  RESTORE_PAGE_FLOWS,
  SET_HISTORY_PAGE_FLOWS,
  GO_TO_HISTORY_PAGE_FLOWS,
  CLEAR_HISTORY_PAGE_FLOWS,
  UPDATE_PAGE_DATA_BY_KEY,
  REMOVE_HISTORY_PAGE_BY_KEY,
  SET_WINDOW_VARIABLE_LIST,
  RESET_PAGES_RUNTIME_CACHE,
  SET_PAGES_CONFIG_LOAD_ERROR,
  CLEAR_PAGES_CONFIG_LOAD_ERROR,
} from "../actionTypes/PagesActionTypes";
import { failMessage } from "./CommonActions";

export const setPagesConfigLoadErrorAction = (payload) => ({
  type: SET_PAGES_CONFIG_LOAD_ERROR,
  payload,
});

export const clearPagesConfigLoadErrorAction = () => ({
  type: CLEAR_PAGES_CONFIG_LOAD_ERROR,
});

//SET SHIPPING DETAILS PAYLOAD
export const setFromMappingPayloadAction = (payload) => {
    return { 
      type: SET_FROM_MAPPING, 
      payload:payload
    };
  };

export const setToMappingPayloadAction = (pageIndex,newFieldMappings)=>{
  return{
    type:SET_TO_MAPPING,
    payload:{
      pageIndex,
      newFieldMappings
    }
  }
}

export const setResourcesListAction = (payload) =>{
  return{
    type:SET_RESOURCES_LIST,
    payload:payload
  }
}

export const setResourcesListByTypesAction = (inputs,outputs)=>{
  return{
    type:SET_RESOURCES_LIST_BY_TYPE,
    payload:{
      inputsVar:inputs,
      outputsVar:outputs
    }
  }
}
export const updateFromMappingFieldsAction = (index,value)=>{
  return{
    type:UPDATE_FROM_MAPPING_FIELDS,
    payload:{
      fromIndex:index,
      fromValue:value
    }
  }
}


export const updateToMappingFieldsAction = (pageIndex,index,value)=>{
  return{
    type:UPDATE_TO_MAPPING_FIELDS,
    payload:{
      pageIndex,pageIndex,
      toIndex:index,
      toValue:value
    }
  }
}

export const removeFromMappingFieldAction =(index)=>{
  return{
    type:REMOVE_FROM_MAPPING_FIELD,
    payload:{
      fromRemoveIndex:index
    }
  }
}


export const removeToMappingFieldAction = (pageIndex,index)=>{
  return{
    type:REMOVE_TO_MAPPING_FIELD,
    payload:{
      pageIndex:pageIndex,
      toRemoveIndex:index
    }
  }
}


export const setToPagesAction =(payload)=>{
  return{
    type: SET_TO_PAGES,
    payload:payload
  }
}

export const removeToPagesAction = (toPageIndex)=>{
  return{
    type:REMOVE_TO_PAGES,
    payload:{
      toPageIndex
    }
  }
}
  
export const setToPagesCondition = (pageIndex,condition)=>{
  return{
    type:SET_TO_PAGE_CONDITION,
    payload:{
      pageIndex,
      condition
    }
  }
}

export const updateToPageAction = (pageIndex, patch) => ({
  type: UPDATE_TO_PAGE,
  payload: { pageIndex, patch }
});

export const clearPagesConfiguration = ()=>{
  return{
    type:CLEAR_PAGES_CONFIG
  }
}

export const markPendingDeletedVariableAction = (variableId) => ({
  type: ADD_PENDING_DELETED_VARIABLE,
  payload: variableId,
});

export const clearPendingDeletedVariablesAction = () => ({
  type: CLEAR_PENDING_DELETED_VARIABLES,
});

export const setPagesHistoryConfigAction = ()=>{
  return {
    type:SET_HISTORY_PAGE_FLOWS,

  }
}
export const removeHistoryPageByKeyAction = (configKey)=>{
  return {
    type: REMOVE_HISTORY_PAGE_BY_KEY,
    payload:{ configKey }
  }
}

export const setWindowVariableListAction = (windowVariableList) => {
  return {
    type: SET_WINDOW_VARIABLE_LIST,
    payload: { windowVariableList }
  };
};

export const goToHistoryPageAction  =()=>{
  return{
    type:GO_TO_HISTORY_PAGE_FLOWS
  }
}

export const clearHistoryPageFlowsAction = () => {
  return {
    type: CLEAR_HISTORY_PAGE_FLOWS,
  };
};

const trySamePageResponseUpdate = (isSamePage, configApiName, toFieldMapping, params, dispatch, getState, automationPageDetails = null) => {
  if (typeof getState !== 'function' || !configApiName) {
    return false;
  }
  const pageFlows = getState()?.PagesReducer?.pageFlows;
  const activeKey = pageFlows?.activePage || pageFlows?.activeWindowPage;
  const hostConfig = activeKey ? pageFlows?.pageData?.[activeKey] : null;
  const automationDetails =
    automationPageDetails || pageFlows?.pageData?.[configApiName] || null;
  const effectiveSamePage =
    isSamePage ||
    resolveIsSamePageAutomation(automationDetails, hostConfig);
  if (isRatesResultsConfig(configApiName, automationDetails)) {
    return false;
  }
  if (!effectiveSamePage) {
    return false;
  }
  const safeParams =
    params && typeof params === 'object' && !Array.isArray(params) ? params : {};
  const { configKey, pages: existingPages } = resolveSamePageHostConfig(
    pageFlows,
    configApiName
  );
  if (!configKey || !existingPages?.html) {
    return false;
  }
  loaderDispatch(dispatch, false);
  // Same-page: mapping-driven replace — no pageFlows/form prefer-rich merge.
  const executeOutputs = normalizePagesGetRatesRedirectOutputs(
    toFieldMapping || {}
  );
  const enrichedOutputs = ensureGetRatesMarkupOutputResponse(
    executeOutputs,
    {}
  );
  const priorResponse =
    existingPages.response &&
    typeof existingPages.response === "object" &&
    !Array.isArray(existingPages.response)
      ? existingPages.response
      : {};
  const normalizedResponse = mergeSamePageExecuteOutputs(
    priorResponse,
    enrichedOutputs
  );
  persistGetRatesExecuteResponse(normalizedResponse);
  const nextParams = applyMappedExecuteOutputsToParams(
    {
      ...omitEphemeralPagesParams(existingPages.params || {}),
      ...omitEphemeralPagesParams(safeParams),
    },
    enrichedOutputs
  );
  dispatch(updatePageDataByKeyAction(configKey, 'pages', {
    ...existingPages,
    params: nextParams,
    response: normalizedResponse
  }));
  return true;
};

// Helper function to fetch page details and handle navigation (extracted from PagesRenderComponent)
const fetchPageDetails = (pageId, configApiName, toFieldMapping, dispatch, history, currentPage = null, pageType = null, params = {}, isSamePage = false, getState = null, automationPageDetails = null) => {
  if (trySamePageResponseUpdate(isSamePage, configApiName, toFieldMapping, params, dispatch, getState, automationPageDetails)) {
    return;
  }
  const searchParams = new URLSearchParams(window.location.search);
  const isPublic = searchParams.get('public') === 'true';
  const domainName = searchParams.get('domain') || 'apps.myship.ca';
  const pagesQuery = buildPagesRouteQuery();
  const pagesWindowQuery = buildPagesRouteQuery({ mode: 'window' });
  const pageDetailsUrl = isPublic && configApiName
    ? `public-pages/${domainName}/${configApiName}/pages/search-by-id/${pageId}`
    : `pages/search-by-id/${pageId}`;

  http.GET(pageDetailsUrl)
    .then(async (res) => {
      // Keep loader until after hydrate + history.push so the source page
      // (Add_shipment_onload) does not paint uncovered before Get Rates mounts.
      const clearLoaderAfterNav = () => {
        setTimeout(() => dispatch({ type: "LOADER", bool: false }), 0);
      };
      if (res.status === 200) {
        const response = res.data;
        if (response.code === 200) {
          console.log('response?.data', response?.data);
          const resData = response?.data;
          const targetConfigKey = resolvePagesTargetConfigKey(
            resData,
            configApiName,
            pageId
          );
          const safeParams =
            params && typeof params === "object" && !Array.isArray(params) ? params : {};
          let shouldNavigateSameWindow = false;
          if (resData?.display_type === 'SAME_WINDOW') {
            if (!isSamePage) {
              dispatch(setPagesHistoryConfigAction());
            }
            shouldNavigateSameWindow = true;
            if (pageType === 'POPUP' && currentPage) {
              dispatch(removeActivePopupPageAction(currentPage));
            }
          } else if (resData?.display_type === 'SEPARATE_WINDOW') {
            const url = `/pages/${targetConfigKey}${pagesWindowQuery}`;
            const { format, width, height } = resData;
            let screenwidth;
            let screenheight;
            let topPosition = 100;
            let leftPosition = 100;

            if (format === "CUSTOM") {
              screenwidth = width;
              screenheight = height;
            } else {
              screenwidth = window.screen.availWidth;
              screenheight = window.screen.availHeight;
            }

            if (window.opener) { window.close(); }
            const windowFeature = `width=${screenwidth},height=${screenheight},top=${topPosition},left=${leftPosition},resizable=no,scrollbars=yes,location=no,status=no`;

            const forceResize = (win) => {
              if (!win.closed) {
                win.resizeTo(screenwidth, screenheight);
                win.focus();
              }
            };

            if (window.childWindow && !window.childWindow.closed) {
              window.childWindow.location.href = url;
              forceResize(window.childWindow);
            } else {
              //Open new window
              window.childWindow = window.open(
                url,
                resData.page_name,
                windowFeature
              );
            }
            dispatch(setPagesHistoryConfigAction());
          } else {
            if (currentPage) {
              dispatch(removeActivePopupPageAction(currentPage));
            }
          }
          // Button redirect Add_shipment → Get_rates_config never hits
          // loadPagesConfigAction(onload:false); strip prior rates snapshot first.
          if (
            typeof getState === "function" &&
            (isRatesResultsConfig(
              targetConfigKey,
              getState()?.PagesReducer?.pageFlows?.pageData?.[targetConfigKey]
            ) ||
              isRatesResultsPageId(pageId))
          ) {
            const ratesKeys = new Set([
              String(targetConfigKey),
              ...collectRatesResultsPageDataKeys(
                getState()?.PagesReducer?.pageFlows
              ),
            ]);
            dispatch(
              resetPagesRuntimeCacheAction({ configKeys: [...ratesKeys] })
            );
          }
          const pageFlowsState =
            typeof getState === "function"
              ? getState()?.PagesReducer?.pageFlows
              : null;
          const normalizedResponse = ensureGetRatesMarkupOutputResponse(
            toFieldMapping || {},
            { pageFlows: pageFlowsState }
          );
          persistGetRatesExecuteResponse(normalizedResponse);
          const pagesPayload = {
            ...response?.data,
            params: safeParams,
            response: normalizedResponse,
          };
          dispatch(loadPageConfigCollectionAction({
            configuration_api_name: targetConfigKey,
            pages: pagesPayload,
            type: 'PAGES',
          }, 'ID', targetConfigKey));//response?.data.id
          queueMicrotask(() => {
            
            dispatch(updatePageDataByKeyAction(targetConfigKey, 'pages', {
              ...pagesPayload
            }));
          });
          if (shouldNavigateSameWindow === true && history) {
            const targetPath = `/pages/${targetConfigKey}${pagesQuery}`;
            const currentFull = `${history.location?.pathname || ''}${history.location?.search || ''}`;
            if (currentFull !== targetPath) {
              history.push(targetPath);
            }
          }
          clearLoaderAfterNav();
        } else {
          dispatch({ type: "LOADER", bool: false });
        }
      } else {
        dispatch({ type: "LOADER", bool: false });
      }
    }, (error) => {
      dispatch({ type: "LOADER", bool: false });
      console.error('Error fetching page details:', error);
    });
};

// RENDER PAGES BLOCK

/** Mode / identity keys promoted into pages.params for Edit toolbar + update_shipment. */
const DIRECT_MODE_PARAM_KEYS = [
  "is_edit",
  "is_clone",
  "pages_edit_mode",
  "pages_clone_mode",
  "pages_mode",
  "record_id",
  "record_ids",
];

const isTruthyDirectModeFlag = (raw) => {
  if (raw === true || raw === 1) {
    return true;
  }
  if (raw == null || raw === false || raw === 0) {
    return false;
  }
  const norm = String(raw).trim().toLowerCase();
  return norm === "true" || norm === "1" || norm === "on" || norm === "yes";
};

const pickDirectModeParams = (vars = {}) => {
  const out = {};
  DIRECT_MODE_PARAM_KEYS.forEach((key) => {
    if (!Object.prototype.hasOwnProperty.call(vars, key)) {
      return;
    }
    const val = vars[key];
    if (val === undefined || val === null || val === "") {
      return;
    }
    out[key] = val;
  });
  return out;
};

/** Merge DIRECT seed into pages.params (toolbar + form hydrate from params). */
const mergeDirectSeedIntoPagesParams = (baseParams = {}, outputVariables = {}) => {
  const next = {
    ...(baseParams && typeof baseParams === "object" && !Array.isArray(baseParams)
      ? baseParams
      : {}),
  };
  // Copy mapped field values (account, addresses, Package, …) — not only mode flags.
  // Form rehydrate reads params+response; Clone must not look like blank Create.
  if (outputVariables && typeof outputVariables === "object") {
    Object.keys(outputVariables).forEach((key) => {
      if (!key || DIRECT_MODE_PARAM_KEYS.includes(key)) {
        return;
      }
      const val = outputVariables[key];
      if (val === undefined || val === null || val === "") {
        return;
      }
      next[key] = val;
    });
  }
  Object.assign(next, pickDirectModeParams(outputVariables));
  // Clone = create save flow: drop shipment id even if list/DIRECT passed record_id.
  if (isTruthyDirectModeFlag(next.is_clone) || isTruthyDirectModeFlag(next.pages_clone_mode)) {
    delete next.record_id;
    delete next.record_ids;
  }
  return next;
};

/** Flatten direct-pages-config-execute data (metaId → variables[]) into { variable_name: value }.
 *  Single record → scalar values. Multiple records → arrays per variable + id lists.
 */
const flattenActionMappedPageVariables = (directData) => {
  const mapped = {};
  if (!directData || typeof directData !== "object") {
    return mapped;
  }
  const metaKeys = Object.keys(directData).filter((uuidKey) =>
    Array.isArray(directData[uuidKey])
  );
  if (metaKeys.length === 0) {
    return mapped;
  }
  const isMulti = metaKeys.length > 1;
  if (isMulti) {
    mapped.meta_table_ids = metaKeys;
    mapped.ids = metaKeys;
    mapped.record_ids = metaKeys;
  }
  metaKeys.forEach((uuidKey) => {
    const variableArray = directData[uuidKey];
    variableArray.forEach((variable) => {
      if (!variable?.variable_name) {
        return;
      }
      const value = variable.selected_value ?? variable.value;
      if (value === undefined || value === null || value === "") {
        return;
      }
      const assignMapped = (key) => {
        if (!key) return;
        if (!isMulti) {
          mapped[key] = value;
          return;
        }
        if (!Object.prototype.hasOwnProperty.call(mapped, key) || !Array.isArray(mapped[key])) {
          // Keep id-list keys as arrays of meta ids; other vars become value arrays.
          if (key === "meta_table_ids" || key === "ids" || key === "record_ids") {
            return;
          }
          mapped[key] = [];
        }
        if (Array.isArray(mapped[key])) {
          mapped[key].push(value);
        }
      };
      assignMapped(variable.variable_name);
      assignMapped(variable.api_name);
      // Add page HTML subform is name="Package"; DIRECT seed uses Packages/packages.
      const nameLower = String(variable.variable_name || "").toLowerCase();
      const apiLower = String(variable.api_name || "").toLowerCase();
      if (
        Array.isArray(value) &&
        (nameLower === "packages" ||
          nameLower === "package" ||
          apiLower === "packages" ||
          apiLower === "package")
      ) {
        ["Package", "Packages", "package", "packages"].forEach((alias) => {
          assignMapped(alias);
        });
      }
    });
  });
  // Clone must save as CREATE — never keep shipment record_id on the Add page.
  const cloneFlag = mapped.is_clone ?? mapped.pages_clone_mode;
  if (isTruthyDirectModeFlag(cloneFlag)) {
    delete mapped.record_id;
    delete mapped.record_ids;
    // Source package metatable ids must not ride into CREATE save.
    ["Package", "Packages", "package", "packages"].forEach((key) => {
      const rows = mapped[key];
      if (!Array.isArray(rows)) {
        return;
      }
      mapped[key] = rows.map((row) => {
        if (!row || typeof row !== "object" || Array.isArray(row) || row.id == null || row.id === "") {
          return row;
        }
        const next = { ...row };
        delete next.id;
        return next;
      });
    });
  }
  return mapped;
};

/** Seed page vars from action-button field mappings (DIRECT display + AUTOMATION execute). */
const fetchActionButtonMappedPageParams = async (configId, action, obj) => {
  if (!configId || !action?.id || !obj || !Array.isArray(obj?.val) || obj.val.length === 0) {
    return {};
  }
  try {
    const directResponse = await PagesServices.getConfigDirect(configId, {
      actionComponentId: action.id,
      layoutId: obj.layoutId,
      windowId: obj.windowId,
      ids: obj.val,
    });
    if (directResponse?.code === 200 && directResponse.data) {
      const flattened = flattenActionMappedPageVariables(directResponse.data);
      // Preserve full multi-select id lists for mass Pages actions (Delete, etc.).
      if (Array.isArray(obj.val) && obj.val.length > 1) {
        flattened.ids = obj.val;
        flattened.meta_table_ids = obj.val;
        flattened.meta_table_id = obj.val;
      }
      if (Array.isArray(obj.record_ids) && obj.record_ids.length > 0) {
        flattened.record_ids = obj.record_ids;
        flattened.record_id =
          obj.record_ids.length > 1 ? obj.record_ids.join(",") : obj.record_ids[0];
      } else if (obj.record_id != null && obj.record_id !== "") {
        flattened.record_id = obj.record_id;
        flattened.record_ids = obj.record_id;
      }
      return flattened;
    }
  } catch (e) {
    console.log("action-button pages mapping seed failed", e);
  }
  return {};
};

export const loadPagesConfigAction = (searchBy, configId, options = {}) => {
  return async (dispatch, getState) => {
    const {
      history,
      onload = false,
      pType = 'DEFAULT',
      action = null,
      obj = null,
      params = null,
      orgWindowId = null,
    } = options || {};
    const current = window.location?.pathname;
    // Same pattern as /layouts/{window_name}: put unique Pages Window id in the URL for orange.
    const pagesQuery = buildPagesRouteQuery({ orgWindowId });
    const pagesWindowQuery = buildPagesRouteQuery({ orgWindowId, mode: 'window' });
    const urls = getGoBackURL?.() || [];

    if (current && urls.length === 0) {
      setGoBackURL(current);
    }

    const getStates = getState();
    const configs = isSet(getStates?.PagesReducer?.pageFlows?.pageData?.[configId], null);
    const shouldStripRuntimeForOpen = (pageFlows, keys, displayType) => {
      if (!keys || keys.length === 0) {
        return false;
      }
      const activeKeys = new Set(
        [pageFlows?.activePage, pageFlows?.activeWindowPage]
          .filter(Boolean)
          .map(String)
      );
      const touchesActiveHost = keys.some((k) => activeKeys.has(String(k)));
      const isPopupTarget =
        displayType === "POPUP" ||
        keys.some((k) => pageFlows?.pageData?.[k]?.pages?.display_type === "POPUP");
      const incomingRecordId = params?.record_id ?? obj?.record_id;
      let cachedRecordId;
      keys.forEach((k) => {
        const rid = pageFlows?.pageData?.[k]?.pages?.params?.record_id;
        if (rid != null) {
          cachedRecordId = rid;
        }
      });
      const recordChanged =
        incomingRecordId != null &&
        cachedRecordId != null &&
        String(incomingRecordId) !== String(cachedRecordId);
      // Keep in-page host runtime; strip popups, inactive targets, or new record_id.
      return isPopupTarget || !touchesActiveHost || recordChanged;
    };
    // List/popup open: clear prior params/response so record N cannot inherit N-1.
    if (onload === false) {
      const flows = getStates?.PagesReducer?.pageFlows;
      const resetKeys = collectPageDataKeysForConfig(flows, configId);
      if (shouldStripRuntimeForOpen(flows, resetKeys)) {
        dispatch(resetPagesRuntimeCacheAction({ configKeys: resetKeys }));
      }
    }
    // Field/button preload: toast missing API name, but do not mark the route page as failed.
    const isSilentPreload = onload === true && pType !== "RENDER";
    const isSoftRecordNotFoundMessage = (msg) => {
      const m = String(msg || "").trim().toLowerCase();
      return m === "record not found." || m === "record not found";
    };
    // Backend sometimes returns generic "Record not found." for missing API names.
    // Prefer the specific message the Kitchen Sink / field preload expects.
    const resolveConfigLoadFailMessage = (rawMessage, notFound) => {
      if (searchBy === "API_NAME" && configId) {
        if (!rawMessage || isSoftRecordNotFoundMessage(rawMessage) || notFound) {
          return `Page Configuration '${configId}' API name is not found.`;
        }
      }
      if (rawMessage) return rawMessage;
      if (notFound) return `Page configuration "${configId}" was not found.`;
      return "No data returned";
    };

    // If this is an onload-only call and we already have page data cached for this key,
    // skip the API call and rely on existing state.
    // if (onload === true){
    //   console.log('configs',configs);
    // }
   
    // if (onload === true && configs && typeof configs === "object" && Object.keys(configs).length > 0) {
    //   return;
    // }
    if (onload === false) {
      loaderDispatch(dispatch, true);
    }
    if (!isSilentPreload) {
      dispatch(clearPagesConfigLoadErrorAction());
    }
    let response;
    //API_NAME
    try {
      if(searchBy === 'ID'){
        response = await PagesServices.getConfigById(configId);
      }else{
        response = await PagesServices.getConfigByName(configId);
      }
      // AUTOMATION keeps loader through pages-config-execute; DIRECT Edit/Clone must
      // also keep it through getConfigDirect (package/subform seed can take 1–2s).
      const willAutoExecuteAfterLoad =
        onload === false &&
        response?.code === 200 &&
        response?.data &&
        response.data.config_type !== 'DIRECT';
      const willDirectSeedAfterLoad =
        onload === false &&
        response?.code === 200 &&
        response?.data?.config_type === 'DIRECT' &&
        (Boolean(action?.id) || obj?.isPagesHyperLink === true);
      if (!willAutoExecuteAfterLoad && !willDirectSeedAfterLoad) {
        loaderDispatch(dispatch, false);
      }
      if(response?.code===200 && response?.data){
        dispatch(clearPagesConfigLoadErrorAction());
        const responseData = response?.data;
        // Config may be keyed by api_name while open used id — strip both before merge.
        if (onload === false && responseData?.configuration_api_name) {
          const flowsNow = getState()?.PagesReducer?.pageFlows;
          const apiKeys = collectPageDataKeysForConfig(
            flowsNow,
            responseData.configuration_api_name
          );
          if (
            shouldStripRuntimeForOpen(
              flowsNow,
              apiKeys,
              responseData?.pages?.display_type
            )
          ) {
            dispatch(resetPagesRuntimeCacheAction({ configKeys: apiKeys }));
          }
        }
        let outputVariables = {};
        // Hoisted so DIRECT + AUTOMATION can share left-nav URL identity stamp (incl. POPUP).
        let shouldNavigateSameWindow = false;
        if(responseData?.config_type==="DIRECT"){
          try{
            if(obj?.isPagesHyperLink===true){
              const postData = {
                hyperlink_field_id: obj?.table_descriptor_id,
                record_id: obj?.record_id,
                layoutId: obj?.layoutId,
                windowId: obj?.windowId,
                ids: obj?.val
              };
              const directResponse = await PagesServices.getConfigDirectHyperLink(configId, postData);
              if (directResponse?.data) {
                outputVariables = flattenActionMappedPageVariables(directResponse.data);
              }
            }else {
              outputVariables = await fetchActionButtonMappedPageParams(configId, action, obj);
            }
            if (Object.keys(outputVariables).length > 0) {
              // Stamp edit session before page collection paint so toolbar uses
              // toolbar_actions_edit on first render (not create + edit duplicate).
              if (
                isTruthyDirectModeFlag(outputVariables.is_edit) &&
                !isTruthyDirectModeFlag(outputVariables.is_clone) &&
                !isTruthyDirectModeFlag(outputVariables.pages_clone_mode)
              ) {
                setShipmentEditSessionActive(true);
              } else if (
                isTruthyDirectModeFlag(outputVariables.is_clone) ||
                isTruthyDirectModeFlag(outputVariables.pages_clone_mode)
              ) {
                setShipmentEditSessionActive(false);
              }
              const dataToStoreForChildOutput = {
                pageId: responseData?.id,
                outputResponse: outputVariables
              };
              localStorage.setItem('directApiOutputForChildWindow', JSON.stringify(dataToStoreForChildOutput));
            }
            if (obj === null && Object.keys(outputVariables).length === 0) {
              const storedOutputStr = localStorage.getItem('directApiOutputForChildWindow');
              if (storedOutputStr) {
                try {
                  const storedOutputData = JSON.parse(storedOutputStr);
                  if (storedOutputData.pageId === responseData?.id) {
                    outputVariables = storedOutputData.outputResponse;
                  }
                  localStorage.removeItem('directApiOutputForChildWindow');
                } catch (parseError) {
                  console.error("Error parsing stored directApiOutputForChildWindow:", parseError);
                  localStorage.removeItem('directApiOutputForChildWindow');
                }
              }
            }
        }catch(error){
          console.log('error',error);
        }
            const pages = responseData?.pages;
            if(pages?.display_type==='SAME_WINDOW' && onload===false){
              // Track same-window navigation in pages history
              dispatch(setPagesHistoryConfigAction());
              shouldNavigateSameWindow = true;
            }else if(pages?.display_type==='SEPARATE_WINDOW' && onload===false){
                const url = `/pages/${responseData?.configuration_api_name}${pagesWindowQuery}`;
              const { format, width, height } = pages;
              let screenwidth;
              let screenheight;
              let topPosition = 100;
              let leftPosition = 100;

              if (format === "CUSTOM") {
                screenwidth = width;
                screenheight = height;
              } else {
                screenwidth = window.screen.availWidth;
                screenheight = window.screen.availHeight;
              }

              if (window.opener) { window.close(); }
              const windowFeature = `width=${screenwidth},height=${screenheight},top=${topPosition},left=${leftPosition},resizable=no,scrollbars=yes,location=no,status=no`;

              const forceResize = (win) => {
                // setTimeout(() => {
                  if (!win.closed) {
                    win.resizeTo(screenwidth, screenheight);
                    // win.moveTo(leftPosition, topPosition);
                    win.focus();
                  }
                // }, 10);
              };

              if (window.childWindow && !window.childWindow.closed) {
                window.childWindow.location.href = url;
                forceResize(window.childWindow);
              } else {
                //Open new window
                window.childWindow = window.open(
                  url,
                  pages.page_name,
                  windowFeature
                );
                //Force resize/reposition
                // if (window.childWindow) {
                //   forceResize(window.childWindow);
                // }
              }

                // const {format,width,height} = pages;
                // let screenwidth =null;//window.screen.availWidth; //null;// 800;
                // let screenheight = null;//window.screen.availHeight;// 600;
                // if(format==="CUSTOM"){
                //   screenwidth = width;
                //   screenheight = height;
                // }
                // else{
                //   // screenwidth=window.screen.availWidth;
                //   // screenheight =window.screen.availHeight;// 600;
                // }
                // if(window.opener){window.close();}
                // // console.log('pages',pages);
                // const windowFeature= `width=${screenwidth},height=${screenheight},top=100,left=100,resizable=no,scrollbars=yes,location=no,status=no`;
                // if (window.childWindow && !window.childWindow.closed) {
                //   window.childWindow.location.href = url; // reload the new URL
                //   window.childWindow.resizeTo(screenwidth, screenheight);
                //   // window.childWindow.moveTo(100, 100);
                //   window.childWindow.focus();
                // } else {
                  
                //   window.childWindow = window.open(
                //     url,
                //     pages.page_name, // window name
                //    windowFeature
                //   );
                // }



                // const childWindow = window.open(
                //     url,
                //     pages.page_name, // window name
                //     `width=${screenwidth},height=${screenheight},top=100,left=100,resizable=no,scrollbars=yes,location=no,status=no`
                // );
                // -------------------------
                //  childWindow.sharedHistoryPush = (path) => {
                //   console.log('pages....');
                //   history.push(path); // parent navigates
                // };
            }
            
            const hasValidParams =
              params != null &&
              typeof params === 'object' &&
              Array.isArray(params) === false;
            const pagesWithParams =
              hasValidParams && isSet(response?.data?.pages, null) !== null
                ? { ...response.data.pages, params }
                : response?.data?.pages;
            // Page UI reads pages.response (not top-level outputVariables).
            // Also promote is_edit/is_clone/record_id into params so toolbar uses
            // toolbar_actions_edit (hide Get Rates, Save → update_shipment).
            const pagesForUi = pagesWithParams
              ? {
                  ...pagesWithParams,
                  ...(Object.keys(outputVariables).length
                    ? {
                        params: mergeDirectSeedIntoPagesParams(
                          pagesWithParams.params,
                          outputVariables
                        ),
                        response: {
                          ...(pagesWithParams.response || {}),
                          ...outputVariables,
                        },
                      }
                    : {}),
                }
              : response?.data?.pages;

            // Merge outputVariables into collections object (consistent with existing pattern)
            const collectionsWithOutput = {
              ...response.data,
              ...(pagesForUi ? { pages: pagesForUi } : {}),
              ...(Object.keys(outputVariables).length
              ? { outputVariables: { ...outputVariables } }
              : {})
            };

            if (onload === true && pType !== 'RENDER') {
              dispatch(loadPageConfigCollectionSilentAction(
                collectionsWithOutput,
                searchBy,
                response?.data?.configuration_api_name
              ));
            } else {
              dispatch(loadPageConfigCollectionAction(
                collectionsWithOutput,
                searchBy,
                response?.data?.configuration_api_name
              ));
            }
            // URL stamp for DIRECT is done once below (covers POPUP + orgWindowId).
        }else{
          const variableResponse = await PagesServices.getConfigVariablesList(responseData?.id, responseData?.configuration_api_name);
          let inputVariables = [];
          let outputVariables = [];
          let windowsIdsForWinVariable = [];
          variableResponse?.data?.content.forEach((vari)=>{
            if(vari.is_request===true){
              inputVariables.push({
                ...vari,type:vari.fieldtype_name
              });
              if(isSet(vari.window_field_id_path,null)!==null){
                windowsIdsForWinVariable.push(vari.window_id);
              }
            }else{
              outputVariables.push({
                ...vari,type:vari.fieldtype_name
              });
            }
          });
          const winIds = [...new Set(windowsIdsForWinVariable)];

          console.log('windowsIdsForWinVariable',winIds);

          // Fetch lookup-layouts metadata for each window id and store in reducer
          let windowVariableList = {};
          for (const windowId of winIds) {
            try {
              const lookupResponse = await PagesServices.getLookupLayoutsByWindowId(windowId);
              if (lookupResponse && lookupResponse.code === 200) {
                windowVariableList[windowId] = lookupResponse.data;
              }
            } catch (e) {
              // fail silently for individual window ids
            }
          }
          if (Object.keys(windowVariableList).length > 0) {
            dispatch(setWindowVariableListAction(windowVariableList));
          }

          dispatch(setResourcesListByTypesAction(inputVariables,outputVariables));
          const hasValidParams =
            params != null &&
            typeof params === 'object' &&
            Array.isArray(params) === false;
          const responseWithParams =
            hasValidParams && isSet(response?.data?.pages, null) !== null
              ? { ...response.data, pages: { ...response.data.pages, params } }
              : response.data;
          queueMicrotask(() => {
            const creator = onload === true && pType !== 'RENDER'
              ? loadPageConfigCollectionSilentAction
              : loadPageConfigCollectionAction;
            dispatch(creator(responseWithParams,searchBy,response?.data?.configuration_api_name));
          });
          
          // Execute API automatically for non-DIRECT config types with default/empty payload
          // let executeOutputVariables = {};
        
          // Merge outputVariables into collections object (consistent with DIRECT type pattern)
          // const collectionsWithOutput = {
          //   ...response.data,
          //   ...(Object.keys(executeOutputVariables).length > 0
          //     ? { outputVariables: { ...executeOutputVariables } }
          //     : {})
          // };
          
          // dispatch(loadPageConfigCollectionAction(collectionsWithOutput,searchBy,response?.data?.configuration_api_name));
        
          const automationPageDetails = response?.data;
          const fromMapping = isSet(automationPageDetails?.from_page_mapping,[]);

          const updatePayload = fromMapping;

          const toMapping = isSet(automationPageDetails?.to_page_mapping,[]);
          // console.log('responseData-data-onload',onload,updatePayload);
          if(onload===false){
            const hostKey = getState()?.PagesReducer?.pageFlows?.activePage;
            const hostConfig = hostKey
              ? getState()?.PagesReducer?.pageFlows?.pageData?.[hostKey]
              : null;
            const samePage = resolveIsSamePageAutomation(
              automationPageDetails,
              hostConfig
            );
            // Seed from_page inputs from action-button field mappings (layout → page vars).
            let executeParams =
              params != null && typeof params === "object" && !Array.isArray(params)
                ? { ...params }
                : {};
            const seeded = await fetchActionButtonMappedPageParams(
              configId,
              action,
              obj
            );
            if (Object.keys(seeded).length > 0) {
              executeParams = { ...executeParams, ...seeded };
              if (response?.data?.configuration_api_name) {
                dispatch(
                  updatePageDataByKeyAction(
                    response.data.configuration_api_name,
                    "pages",
                    {
                      ...(responseWithParams?.pages || response?.data?.pages || {}),
                      params: executeParams,
                    }
                  )
                );
              }
            }
            executeAPI(
              automationPageDetails,
              updatePayload,
              toMapping,
              false,
              samePage,
              history,
              dispatch,
              searchBy,
              executeParams,
              getState
            );
          }
        }
        // Left-nav orange identity: always put /pages/{api}?org_window_id= on the URL when
        // opened from a Pages Window (orgWindowId), including DIRECT+POPUP (modal does not
        // change route by itself). SAME_WINDOW also navigates here via shouldNavigateSameWindow.
        if (
          history &&
          responseData?.configuration_api_name &&
          (shouldNavigateSameWindow === true || orgWindowId)
        ) {
          const targetPath = `/pages/${responseData.configuration_api_name}${pagesQuery}`;
          const currentFull = `${history.location?.pathname || ''}${history.location?.search || ''}`;
          if (currentFull !== targetPath) {
            history.push(targetPath);
          }
        }
        if (responseData?.config_type==="DIRECT" && params != null && typeof params === 'object' && response?.data?.configuration_api_name) {
          // Preserve DIRECT mode flags (is_edit / is_clone) — raw click params are
          // often only { record_id }. Overwriting wiped edit toolbar → create+edit
          // both painted until reload (session).
          const paramsForPatch = mergeDirectSeedIntoPagesParams(
            params,
            outputVariables || {}
          );
          queueMicrotask(() => {
            const pagesPatch = {
              ...isSet(response?.data?.pages, {}),
              params: paramsForPatch,
            };
            if (Object.keys(outputVariables || {}).length) {
              pagesPatch.response = {
                ...(response?.data?.pages?.response || {}),
                ...outputVariables,
              };
            }
            dispatch(
              updatePageDataByKeyAction(
                response.data.configuration_api_name,
                "pages",
                pagesPatch
              )
            );
          });
          
        }
        // Clear after DIRECT seed + route stamp (same timing idea as Get Rates clearLoaderAfterNav).
        if (willDirectSeedAfterLoad) {
          setTimeout(() => loaderDispatch(dispatch, false), 0);
        }
      } else {
        loaderDispatch(dispatch, false);
        const isNotFound = isPagesConfigNotFoundError(null, response);
        const message = resolveConfigLoadFailMessage(response?.message, isNotFound);
        // Collected into one toast with other parallel page-open failures.
        dispatch(failMessage(message));
        if (!isSilentPreload) {
          dispatch(
            setPagesConfigLoadErrorAction({
              configKey: configId,
              message,
              isNotFound,
            })
          );
        }
      }
    } catch (error) {
      loaderDispatch(dispatch, false);
      // http interceptor may reject with response object (not AxiosError).
      const status = error?.response?.status ?? error?.status;
      const apiMessage =
        error?.response?.data?.message || error?.data?.message || null;
      const isNotFound =
        status === 404 ||
        isPagesConfigNotFoundError(error, error?.data || error?.response?.data);
      const fallback = resolvePagesHttpErrorMessage(
        error,
        `Unable to load page configuration "${configId}".`
      );
      const message = resolveConfigLoadFailMessage(
        apiMessage || (isNotFound ? null : fallback),
        isNotFound
      );
      dispatch(failMessage(message));
      if (!isSilentPreload) {
        dispatch(
          setPagesConfigLoadErrorAction({
            configKey: configId,
            message,
            isNotFound,
          })
        );
      }
    }
  };
};
export const loaderDispatch = (dispatch,bool) => {
  if(dispatch){
    dispatch({
      type: "LOADER",
      bool: bool
    });
  }
}

export const executeAPI = (automationPageDetails, updatePayload, toMapping, isbackgroundProcess = false, isSamePage = false, history, dispatch = null, searchBy = null, params = {}, getState = null) => {
  const url = `pageconfig/${automationPageDetails.id}/pages-config-execute`;
  try {
      loaderDispatch(dispatch,true);
      const resourcesList = getState?.()?.PagesReducer?.resourcesList;
      const pageFlows = getState?.()?.PagesReducer?.pageFlows;
      const mergedParams = buildMergedPagesExecuteParams({
        pageFlows,
        automationApiName: automationPageDetails?.configuration_api_name,
        params,
        resolveHostConfig: resolveSamePageHostConfig,
      });
      const postPayload = wrapPagesConfigExecutePayload(
        buildPagesConfigExecutePayload({
          fromMapping: updatePayload,
          resourcesList,
          automationType: automationPageDetails?.automation_type,
          params: mergedParams,
        }),
        mergedParams
      );
      http.POST(url, postPayload)
          .then(async (response) => {
              const responseData = response.data;
              if (responseData.code === 200) {
                  const resData = responseData?.data;
                  if (!resData) {
                    // Batched with other page-open errors into one toast (CommonActions.failMessage).
                    if (dispatch) {
                      dispatch(failMessage(responseData?.message || "No data returned"));
                    }
                    loaderDispatch(dispatch,false);
                    return;
                  }
                  let outputResponse = {};
                  let variables = isSet(resData?.variables, []);
                  if (automationPageDetails?.automation_type === 'API') {
                      isSet(resData, []).forEach((rData) => {
                          variables = [...variables, ...isSet(rData.variables, [])];
                      })
                  }
                  try {
                      variables.forEach((v) => {
                          outputResponse = {
                              ...outputResponse,
                              [isSet(v.api_name, v.apiName)]: v
                          }
                      });
                  } catch (e) {}

                  // console.log('outputResponse',outputResponse);
                  //  this.props.Loader(false);
                  // console.log('variables',variables);
                  // let outputErrorMsg = outputResponse?.Error_messages?.value;
                  // if ((responseData.messages !== undefined && responseData.messages.length > 0) || isSet(outputErrorMsg, []).length > 0) {
                  //   let errorMessageList = isSet(responseData.messages, isSet(outputErrorMsg, []), 'ARRAY');
                  //   // console.log('errorMessageList',errorMessageList);
                  //   // this.props.setErrorListAction(errorMessageList);
                  //   if (!this.props.isErrorModalOpen) {
                  //                 this.props.Loader(false);
                  //     // this.props.showErrorDetailsAction();
                  //   }
                  // }
                  // console.log('automationPageDetails',automationPageDetails?.configuration_api_name);
                  let isConditionTrue = false;
                  const safeToMapping = orderToPageMappingForExecute(toMapping);
                  for (let i = 0; i < safeToMapping.length; i++) {
                      const toMap = safeToMapping[i];
                      const isTrue = evaluatePagesMessageCondition(toMap?.condition, outputResponse);
                      if (!isTrue) continue;
                      isConditionTrue = true;
                      if (isToPageRedirectMode(toMap)) {
                          const didRedirect = resolveAndNavigateRedirect({
                              redirectConfig: toMap.redirect,
                              variables,
                              history,
                          });
                          if (didRedirect) {
                              loaderDispatch(dispatch, false);
                              return;
                          }
                          // Condition matched but redirect URL unresolved (null
                          // record id / DETAIL) — clear loader, stay on page.
                          loaderDispatch(dispatch, false);
                          break;
                      }
                      const valuesArray = variables;
                      let toFieldMapping = isSet(toMap?.field_mappings, []).map((mField) => ({
                          ...mField,
                          value: resolveMappedVariableValue(mField, valuesArray),
                      }));
                      let toFieldMappingOutputs = {};
                      let pageId = toMap?.page_id;
                      const getRatesRedirect = isGetRatesPageRedirectTarget(
                        toMap,
                        pageId
                      );
                      const pageFlowsForExecute =
                        typeof getState === 'function'
                          ? getState()?.PagesReducer?.pageFlows
                          : null;
                      const pageFlowsState = pageFlowsForExecute;
                      const hostKey =
                        pageFlowsState?.activePage || pageFlowsState?.activeWindowPage;
                      const hostConfig = hostKey
                        ? pageFlowsState?.pageData?.[hostKey]
                        : null;
                      const effectiveSamePage = getRatesRedirect
                        ? false
                        : isSamePage ||
                          resolveIsSamePageAutomation(
                            automationPageDetails,
                            hostConfig
                          );
                      // Add_shipment_onload → Get_rates_config: prior rates pageData
                      // was still merged into outputs (route strip only clears prevKey).
                      if (getRatesRedirect && dispatch && typeof getState === "function") {
                        const ratesKeys = collectRatesResultsPageDataKeys(
                          getState()?.PagesReducer?.pageFlows
                        );
                        const targetApi = resolvePagesRedirectTargetConfigApiName(
                          toMap,
                          pageId
                        );
                        if (targetApi) {
                          ratesKeys.push(String(targetApi));
                        }
                        if (ratesKeys.length > 0) {
                          dispatch(
                            resetPagesRuntimeCacheAction({
                              configKeys: [...new Set(ratesKeys)],
                            })
                          );
                        }
                      }
                      const mappedExecuteOutputs = normalizePagesGetRatesRedirectOutputs(
                        buildPagesRedirectFieldOutputs(toFieldMapping, postPayload),
                        { hyperthreadVariables: variables }
                      );
                      try {
                          toFieldMappingOutputs = ensureGetRatesMarkupOutputResponse(
                            mappedExecuteOutputs,
                            effectiveSamePage
                              ? { hyperthreadVariables: variables }
                              : {
                                  hyperthreadVariables: variables,
                                  pageFlows: pageFlowsForExecute,
                                  fieldFormPayload:
                                    buildFieldFormPayloadFromExecuteMappings(
                                      postPayload
                                    ),
                                }
                          );
                      } catch (e) {
                          console.error("Get Rates redirect output mapping failed", e);
                          toFieldMappingOutputs = ensureGetRatesMarkupOutputResponse(
                            effectiveSamePage ? mappedExecuteOutputs : {},
                            effectiveSamePage
                              ? { hyperthreadVariables: variables }
                              : {
                                  hyperthreadVariables: variables,
                                  pageFlows: pageFlowsForExecute,
                                }
                          );
                      }
                      persistGetRatesExecuteResponse(toFieldMappingOutputs);
                      if (!isbackgroundProcess) {
                          if (effectiveSamePage && typeof getState === 'function') {
                              pageId =
                                hostConfig?.pages?.id ??
                                pageId;
                          }
                          if (dispatch) {
                              // Cross-page: toMap → display/rates config. Avoid automation api_name as key.
                              const redirectConfigApiName = effectiveSamePage
                                ? automationPageDetails?.configuration_api_name
                                : resolvePagesRedirectTargetConfigApiName(
                                    toMap,
                                    pageId
                                  );
                              fetchPageDetails(
                                  pageId,
                                  redirectConfigApiName ||
                                    automationPageDetails?.configuration_api_name,
                                  toFieldMappingOutputs,
                                  dispatch,
                                  history,
                                  null,
                                  null,
                                  params,
                                  effectiveSamePage,
                                  getState,
                                  automationPageDetails
                              );
                          }
                      }
                      break;
                  }
                  if (!isConditionTrue) {
                    loaderDispatch(dispatch,false);
                  }

                  // console.log('outputResponse',JSON.stringify(outputResponse));

              } else {
                loaderDispatch(dispatch,false);
                if (dispatch) {
                  dispatch(
                    failMessage(
                      responseData?.message ||
                        "Page automation failed. Please try again."
                    )
                  );
                }
              }
          }, (error) => {
            loaderDispatch(dispatch,false);
            console.log(error);
            if (dispatch) {
              dispatch(
                failMessage(
                  resolvePagesHttpErrorMessage(
                    error,
                    "Page automation request failed. Please try again."
                  )
                )
              );
            }
          })
  } catch (error) {
      console.error("Error in executeAPI:", error);
      loaderDispatch(dispatch, false);
      if (dispatch) {
        dispatch(
          failMessage(
            resolvePagesHttpErrorMessage(
              error,
              "Page automation request failed. Please try again."
            )
          )
        );
      }
  }
}

export const restorePageFlowsAction = ()=>{
  return{
    type:RESTORE_PAGE_FLOWS,
    payload:{}
  }
}

export const resetPagesRuntimeCacheAction = (payload = {}) => ({
  type: RESET_PAGES_RUNTIME_CACHE,
  payload,
});



export const toPagesRulesCheck = (rules,outputResponse)=>{

  let validationResult ='(true===true)';
  if(rules.length>0){
    validationResult+=' && (';
  }
  rules.forEach((rule,ruleIndex)=>{
    const conditionField = {
        isExist:isSet(outputResponse['pages_message'],null)!==null?true:false,
        field:{type:'TextInput',...outputResponse['pages_message'],selectedValue:outputResponse['pages_message']?.value},
        selectedValue:outputResponse['pages_message']?.value}
    if(conditionField.isExist===true){
      if(ruleIndex>0){
        if(isSet(rule.logical_operator,'')==='AND'){
          validationResult+=' &&';
        }else if(isSet(rule.logical_operator,'')==='OR'){
          validationResult+=' || ';
        }
      }
    //   console.log('filter',isSet(rule.filter_name,'equal to'));
      validationResult+=' (true==='+conditionRulesChecking(
        conditionField,
        {values:rule.value,filter:isSet(rule.filter_name,'is not empty')})+' )';
        
    }else{
      if(ruleIndex>0){
        validationResult+=' &&';
      }
      validationResult+='(true===false)';
    }
  });
  if(rules.length>0){
    validationResult+=')';
  }
//   console.log('conditionField',validationResult);
  try{
    if(eval("("+validationResult+")")){
      return true;
    }
  }catch(e){

  }
  return false;
}
export const loadPageConfigCollectionAction =(collections,searchBy,configKey)=>{
  // console.log(" collect ---" , collections , searchBy , configKey);
  const enriched = applyPagesConfigFeatureFlags(collections, configKey);
  return{
    type:LOAD_CONFIG_COLLECTION,
    payload:{
          collections:enriched,
          identifer:searchBy,
          configKey:configKey
        }
  }
}

export const loadPageConfigCollectionSilentAction =(collections,searchBy,configKey)=>{
  const enriched = applyPagesConfigFeatureFlags(collections, configKey);
  return{
    type:LOAD_CONFIG_COLLECTION_SILENT,
    payload:{
          collections:enriched,
          identifer:searchBy,
          configKey:configKey
        }
  }
}

export const setActiveConfigPagesAction = (type,page)=>{
  return{
    type:SET_ACTIVE_CONFIG_PAGE,
    payload:{
      pageDesignType:type,
      pageConfigKey:page
    }
  }
}

export const removeActivePopupPageAction =(configKey)=>{
  return{
    type:REMOVE_ACTIVE_POPUP_PAGE,
    payload:{
      removingConfigKey:configKey
    }
  }
}

export const updatePageFlowsDataAction = (apiName,key,data)=>{
  return{
    type:UPDATE_PAGE_FLOWS_DATA,
    payload:{
      configApiName:apiName,
      pageDataKey:key,
      pageDataValue:data
    }
  }
}
// END OF RENDER PAGES BLOCK

/**
 * Shallow-merge page data for a given config key into pageFlows.pageData.
 * If targetKey (e.g. 'pages') is passed, the patch is merged into pageData[configKey][targetKey],
 * copying existing nested data first. Otherwise the patch is merged into pageData[configKey].
 */
export const updatePageDataByKeyAction = (configKey,targetKey = null, patch) => ({
  type: UPDATE_PAGE_DATA_BY_KEY,
  payload: {
    configKey,
    targetKey,
    patch
  }
});


